import React from 'react';
import { muiPasswordShow, muiPasswordHide } from '@ally/metronome-icons';
import { useAriaLive } from '@ally/use-aria-live';
import { useAdornmentState, usePasswordMaskAdornment } from '../context';
import { a11y } from '../../../strings';
export const usePasswordMask = ({ onClick, getAriaLivePasswordVisible = a11y.getAriaLivePasswordVisible, ariaLabelShowPassword = a11y.ariaLabelShowPassword, ariaLabelHidePassword = a11y.ariaLabelHidePassword, }) => {
    const { isMasked, setMasked, inputValue, setMaskRef } = usePasswordMaskAdornment();
    const { isBlurred, inputRef, onBlurRelatedTarget } = useAdornmentState();
    const { announceAssertive } = useAriaLive();
    const handleToggleMask = (e) => {
        var _a, _b;
        if (isMasked) {
            announceAssertive(
            // Convert to string as it could be a number and we want "0" to evaluate as truthy
            (inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString())
                ? getAriaLivePasswordVisible(inputValue.toString())
                : '');
        }
        else {
            announceAssertive(a11y.ariaLivePasswordHidden);
        }
        setMasked(!isMasked);
        (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    const handleBlurMask = (e) => {
        const isInput = e.relatedTarget === inputRef.current;
        if (!isMasked && !isInput)
            setMasked(true);
    };
    const maskRef = React.useRef(null);
    React.useEffect(() => {
        setMaskRef(maskRef);
    }, []);
    React.useEffect(() => {
        const isMaskButton = onBlurRelatedTarget === maskRef.current;
        if (isBlurred && !isMaskButton)
            setMasked(true);
    }, [isBlurred, onBlurRelatedTarget]);
    return {
        variant: 'custom',
        position: 'right',
        item: {
            ref: maskRef,
            variant: 'interactive',
            'aria-label': isMasked ? ariaLabelShowPassword : ariaLabelHidePassword,
            'data-testid': 'mui-password-mask-adornment',
            onClick: handleToggleMask,
            onBlur: handleBlurMask,
            icon: {
                icon: isMasked ? muiPasswordShow : muiPasswordHide,
                fill: 'slate-4',
            },
        },
    };
};
//# sourceMappingURL=usePasswordMask.js.map